import React from 'react';
import { WebUiSelect } from 'src/modules/web-ui/components/select';

function queueLabel(queue: number): string {
  const labels = [
    'Q0 (weighted, 1x)',
    'Q1 (weighted, 2x)',
    'Q2 (weighted, 3x)',
    'Q3 (weighted, 6x)',
    'Q4 (weighted, 12x)',
    'Q5 (3rd strict)',
    'Q6 (2nd strict)',
    'Q7 (1st strict)',
  ];
  return labels[queue] ?? `Q${queue}`;
}

function DscpMatrix({
  title,
  values,
  readonly,
  onChange,
  optionLabel,
}: {
  title: string;
  values: number[];
  readonly: boolean;
  onChange: (idx: number, value: number) => void;
  optionLabel: (v: number) => string;
}) {
  return (
    <div className="flex w-full flex-col gap-2">
      <h4 className="font-bold">{title}</h4>
      <table className="webui-table w-full">
        <thead>
          <tr className="webui-table-row-head">
            <th>DSCP</th>
            <th>{title.includes('PCP') ? 'PCP' : 'Queue'}</th>
            <th className="bg-white" />
            <th>DSCP</th>
            <th>{title.includes('PCP') ? 'PCP' : 'Queue'}</th>
            <th className="bg-white" />
            <th>DSCP</th>
            <th>{title.includes('PCP') ? 'PCP' : 'Queue'}</th>
            <th className="bg-white" />
            <th>DSCP</th>
            <th>{title.includes('PCP') ? 'PCP' : 'Queue'}</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 16 }, (_unusedRow, row) => (
            <tr key={row} className="webui-table-row-content">
              {[0, 16, 32, 48].map((offset, col) => {
                const idx = row + offset;
                return (
                  <React.Fragment key={idx}>
                    <td className="text-center">{idx}</td>
                    <td>
                      <WebUiSelect
                        inputSize="sm"
                        className="w-full"
                        options={Array.from({ length: 8 }, (_, i) => ({
                          label: optionLabel(i),
                          value: i.toString(),
                        }))}
                        disabled={readonly}
                        value={values[idx]}
                        onChange={(e) => onChange(idx, Number(e.target.value))}
                      />
                    </td>
                    {col < 3 ? <td className="!bg-white" /> : null}
                  </React.Fragment>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function QosDscpQueueMatrix({
  values,
  readonly,
  onChange,
}: {
  values: number[];
  readonly: boolean;
  onChange: (idx: number, value: number) => void;
}) {
  return (
    <DscpMatrix
      title="DSCP Mapping"
      values={values}
      readonly={readonly}
      onChange={onChange}
      optionLabel={queueLabel}
    />
  );
}

export function QosDscpPcpMatrix({
  values,
  readonly,
  onChange,
}: {
  values: number[];
  readonly: boolean;
  onChange: (idx: number, value: number) => void;
}) {
  return (
    <DscpMatrix
      title="DSCP -> PCP Mapping"
      values={values}
      readonly={readonly}
      onChange={onChange}
      optionLabel={(v) => String(v)}
    />
  );
}
